export default __webpack_public_path__ + "static/map-8d0c7e06e691a8f2723fb067ecc0d9e3.webp";